module.exports = __webpack_public_path__ + "media/images/e-bilet/clock_active-489656c08f805a6b5ed9ee6a1b5c8e2b.svg";